<template>
    <b-container>
        <!-- Final step -->
        <final
                v-if="userAnswers.isFinished"
        ></final>

        <!-- User information -->
        <user-info
                v-if="!userAnswers.isFinished && generalStep === 1"
        ></user-info>

        <!-- Answers for questions -->
        <answers
                v-else-if="!userAnswers.isFinished && generalStep === 2"
        ></answers>

        <!-- Answers for general questions -->
        <general-answers
                v-else-if="!userAnswers.isFinished && generalStep === 3"
        ></general-answers>
    </b-container>
</template>

<script>
    import final from './final';
    import answers from './answers';
    import userInfo from './user-info';
    import generalAnswers from './general-answers';

    import {mapActions, mapGetters, mapMutations} from 'vuex';

    export default {
        props: {
            isDemo: Boolean,
        },
        mounted() {
            this.setDemoTest(this.isDemo);
            this.getApiData(this.$route.params.hash, this.isDemo).then(response => {
                if (response.testConfigFailed) {
                    this.setGlobalNotification({
                        type: 'danger',
                        message: this.$t('notifications.errors.test_config_failed')
                    });
                    this.$router.push({name: 'homepage'});
                }
                if (response && response.test && response.test.language_country && response.test.language_country.language) {
                    this.$root.setLang(response.test.language_country.language.toLowerCase())
                }
            });
        },
        computed: {
            ...mapGetters({
                user: 'auth/user',
                isFinished: 'testFlow/isFinished',
                generalStep: 'testFlow/generalStep',
                userAnswers: 'testFlow/userAnswers',
            })
        },
        methods: {
            ...mapActions({
                getApiData: 'testFlow/getApiData',
                getVerificationCode: 'testFlow/getVerificationCode'
            }),
            ...mapMutations({
                setDemoTest: 'testFlow/setDemoTest',
                setFinishTest: 'testFlow/setFinishTest',
                setGlobalNotification: 'setGlobalNotification',
                setVerificationCode: 'testFlow/setVerificationCode',
                generalStepIncrement: 'testFlow/generalStepIncrement',
                generalStepDecrement: 'testFlow/generalStepDecrement',
            }),
            finalStep() {
                this.getVerificationCode({
                    hash: this.$route.params.hash,
                    userAnswers: this.userAnswers
                }).then(response => {
                    this.setVerificationCode(response.verificationCode);
                });
            }
        },
        components: {
            final,
            answers,
            userInfo,
            generalAnswers,
        }
    }
</script>
